import { BreachPathIssueNameKey } from '../types';

export const breachPathIssueNameMapping: Record<string, string> = {
  [BreachPathIssueNameKey.Unknown]: 'Unknown security risk',

  // AWS
  [BreachPathIssueNameKey.PublicInternetToEC2ViaPublicIP]: 'Internet-exposed virtual machine via public IP',
  [BreachPathIssueNameKey.PublicInternetToApplicationLoadBalancerFQDNtoEC2]: 'Internet-exposed virtual machine via Application Load Balancer',
  [BreachPathIssueNameKey.CloudFrontOptionalToS3PublicToEC2AsAPIServerViaPublicIP]: 'Internet-exposed API server via CloudFront, with optional S3 public access',
  [BreachPathIssueNameKey.CloudFrontOptionalToS3PublicToNetworkLoadBalancerFQDNtoEC2APIServer]: 'Internet-exposed API server utilizing Network Load Balancer and CloudFront, with optional S3 public access',
  [BreachPathIssueNameKey.APIGatewayToNetworkLoadBalancerFQDNtoEC2APIServer]: 'Internet-exposed API server with API Gateway & Network Load Balancer',
  [BreachPathIssueNameKey.PublicInternetToClassicLoadBalancerFQDNtoEC2]: 'Internet-exposed virtual machine via Classic Load Balancer',

  // AZR
  [BreachPathIssueNameKey.PublicVM]: 'Internet-exposed virtual machine via public IP',
  [BreachPathIssueNameKey.PrivateVMViaLoadBalancer]: 'Internet-exposed virtual machine via Load Balancer',
  [BreachPathIssueNameKey.PublicVMViaLoadBalancer]: 'Internet-exposed virtual machine via Load Balancer',
  [BreachPathIssueNameKey.OutboundRoutingToVM]: 'Internet-exposed virtual machine via outbound routing',
};
